import { forwardRef } from 'react';

import { IconProps } from './icons.types';

export const ArrowUpIcon = forwardRef<SVGSVGElement, IconProps>(function ArrowUpIcon(
  { color = '', height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.37017 6.94588C9.16573 6.68471 8.83427 6.68471 8.62983 6.94588L6.15438 10.1083C5.82459 10.5296 6.05816 11.25 6.52455 11.25H11.4755C11.9418 11.25 12.1754 10.5296 11.8456 10.1083L9.37017 6.94588Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
